import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { PENN_DOT_BLUE } from "../constants/styleConstants";

export default function ReportSection({
  children,
  borderColor = PENN_DOT_BLUE,
  title,
}) {
  const BORDER_STYLE = `2px solid ${borderColor}`;
  return (
    <div
      style={{
        marginBottom: "50px",
        overflowWrap: "break-word",
      }}
    >
      <div style={{ padding: "20px" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Typography sx={{ fontWeight: "700" }} variant="h5">
            {title}
          </Typography>
        </div>
      </div>
      <div
        style={{ borderBottom: BORDER_STYLE, height: "2px", width: "100%" }}
      ></div>
      <div style={{ padding: "20px 0" }}>{children}</div>
    </div>
  );
}

ReportSection.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};
